<div class="modal-header">
    <h5 class="modal-title fw-bold ms-2" id="exampleModalLabel">Marcos retributivos</h5>
    <button type="button" class="close close-m" mat-dialog-close>
        <img src="./assets/img/x-black.svg" width="18" class="close-aviso--1">
    </button>
</div>

<div class="modal-body">
    <div class="container m-0 p-0">
        <div class="row m-0">
            <div class="col-12 ps-2 col-xl">
                <!-- AMENA -->
                <div class="card--notify mb-2" *ngIf="permSv.hasPermFromV2(allPermissions.amena.permite_activaciones) && data?.autoInvoiceData?.mr">
                    <div class="card-body--notify">
                        <div class="row m-0" style="column-gap: 16px;">
                            <div class="col p-0">
                                <div class="row m-0">
                                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center p-0">
                                        <img src="./assets/img/am-login-color.svg" width="80">
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto d-flex align-items-center p-0">
                                <a [href]="data?.autoInvoiceData.mr.amena" target="_blank" class="fw-bold black">Marco retributivo Amena</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ALL NEW BRANDS -->
                <div class="card--notify mb-2" *ngIf="(
                    permSv.hasPermFromV2(allPermissions.simyo.permite_vender) || 
                    permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas) || 
                    permSv.hasPermFromV2(allPermissions.masmovil.vende_masmovil) || 
                    permSv.hasPermFromV2(allPermissions.guuk.vende_guuk) || 
                    permSv.hasPermFromV2(allPermissions.pepephone.vende_pepephone)) 
                    && data?.autoInvoiceData?.mr">
                    
                    <div class="card-body--notify">
                        <div class="row m-0" style="column-gap: 16px;">
                            <div class="col p-0">
                                <div class="row m-0">
                                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center p-0">
                                        <img src="./assets/img/sm-login-color.svg" width="80">
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center p-0">
                                        <img src="./assets/img/jz-login-color.svg" width="80">
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center p-0">
                                        <img src="./assets/img/mm-login-color.svg" width="80">
                                    </div>
                                </div>
                                <div class="row m-0 ">
                                    <div class="col-12 p-0 d-flex justify-content-center">
                                        <img src="./assets/img/pp-login-color.svg" width="80">
                                        <img src="./assets/img/gk-login-color.svg" width="80">
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto d-flex align-items-center p-0">
                                <a [href]="data?.autoInvoiceData?.mr" target="_blank" class="fw-bold black">Marco Retributivo multimarca</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ORANGE -->
                <!-- <div class="card--notify mb-2" *ngIf="(permSv.hasPermFromV2(allPermissions.orange.permite_ventas_prepago) || permSv.hasPermFromV2(allPermissions.orange.permite_ventas_pospago)) && data?.autoInvoiceData?.mr?.orange">
                    <div class="card-body--notify">
                        <div class="row m-0" style="column-gap: 16px;">
                            <div class="col p-0">
                                <div class="row m-0">
                                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center p-0">
                                        <img src="./assets/img/or-login-color.svg" width="80">
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto d-flex align-items-center p-0">
                                <a [href]="data?.autoInvoiceData?.mr?.orange" target="_blank" class="fw-bold black">Marco retributivo Orange</a>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Jazztel -->
                <!-- <div class="card--notify mb-2" *ngIf="permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas) && data?.autoInvoiceData?.mr?.jazztel">
                    <div class="card-body--notify">
                        <div class="row mb-0">
                            <div class="col-12 col-sm">
                                <img src="./assets/img/jz-login-color.svg" class="img-fluid marca--rm soporte--logo" width="120">
                            </div>
                            <div class="col-12 col-sm-auto">
                                <p class="pt-4 text-right">
                                    <a [href]="data?.autoInvoiceData?.mr?.jazztel_old" target="_blank" class="fw-bold black">Marco Retributivo Jazztel anterior</a>
                                </p>
                                <p class="pt-4 text-right">
                                    <a [href]="data?.autoInvoiceData?.mr?.jazztel" target="_blank" class="fw-bold black">Marco Retributivo multimarca vigente</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div> -->
                
            </div>
        </div>
    </div>
</div>
